// removed by extract-text-webpack-plugin
module.exports = {"fullscreenButton":"map-module__fullscreenButton___L_zZB","leafletMap":"map-module__leafletMap___1vpz-","region":"map-module__region___1AgaV","navigationControlBtns":"map-module__navigationControlBtns___2rBWn"};


//////////////////
// WEBPACK FOOTER
// ./src/components/map/map.module.scss
// module id = 191
// module chunks = 0